import validate from "validate.js";
import * as customValidators from "./validators";

validate.validators = {
  ...validate.validators,
  ...customValidators,
};

export default validate;
